import { gql } from '@apollo/client';
import { Spinner } from 'components/spinner';
import {
  Events,
  useSearchEventsLazyQuery,
  SearchEventsQueryResult,
} from 'lib/graphql-generated';
import { Dispatch, SetStateAction } from 'react';
import { MultiSelect, MultiSelectData } from './multi-select';

const SEARCH_EVENTS = gql`
  query SearchEvents($search: String) {
    events(where: { _and: [{ title: { _ilike: $search } }] }) {
      slug
      title
      id
      start_time
    }
  }
`;

export type EventSelectorValue = MultiSelectData<
  SearchEventsQueryResult['data']['events'][0]
>;

export const SerializeEvents = (
  categories: Partial<Events>[]
): EventSelectorValue[] => {
  const arr =
    categories?.map(
      (c): EventSelectorValue =>
        c && {
          label: c.title,
          key: c.id,
          data: {
            title: c.title,
            id: c.id,
            start_time: c.start_time,
            slug: c.slug,
          },
        }
    ) ?? [];

  return arr.filter((obj) => obj);
};

interface Props {
  label?: string;
  value: EventSelectorValue[];
  setValue: Dispatch<SetStateAction<MultiSelectData<Partial<Events>>[]>>;
  className?: string;
}

export function EventSelector({ label, value, setValue, className }: Props) {
  const [search, { data, loading, error }] = useSearchEventsLazyQuery({
    fetchPolicy: 'no-cache',
  });

  const handleSearch = (value) => {
    if (value.length >= 2) {
      search({ variables: { search: `%${value}%` } });
    }
  };

  return (
    <MultiSelect
      className={className}
      id={label?.replace(' ', '') || 'eventSelector'}
      label={label}
      onSearch={handleSearch}
      placeholder='Search by event name'
      searchResults={data?.events.map((e) => ({
        label: e.title,
        key: e.id,
        data: e,
      }))}
      values={value}
      setValues={setValue}
      notFoundContent={loading ? <Spinner /> : null}
      singleSelect={true}
    />
  );
}
